import { render, staticRenderFns } from "./MenuRouterLink.vue?vue&type=template&id=4865cebb"
import script from "./MenuRouterLink.vue?vue&type=script&lang=js"
export * from "./MenuRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports